import ApplicationHeader from "../layouts/ApplicationHeader";
import NewReportComponent from "./ReportsPage/NewReportComponent";

export default function ReportPages() {
  // Function to generate the question / ui/ux card for each group
  const generateQuestionGroup = (groupConfig, questionGroupConfig) => {
    return groupConfig?.map((question, index) => {
      return (
        <div className="report-question-group-container" key={question}>
          <p className="report-question-group-container-question">
            {groupConfig?.[index]}
          </p>
          {questionGroupConfig?.[index]}
        </div>
      );
    });
  };

  return (
    <>
      <ApplicationHeader headerName={"Reports"} />
      <NewReportComponent generateQuestionGroup={generateQuestionGroup} />
    </>
  );
}
